import React, { Fragment } from 'react';
import './style.css';

// TODO: Improve error display here
const Footer = ({
  disabled, isLoading, onCancel, onSave, error
}) => (
  <div className="teacher-listing-footer d-flex px-4 px-lg-5 py-4">
    <Fragment>
      <button
        type="button"
        className="btn btn-primary btn-lg btn-blue btn-cursor btn-teacher-dashboard"
        onClick={onSave}
        disabled={isLoading || disabled}
      >
        Save
      </button>
      <button
        type="button"
        className="btn btn-secondary btn-lg btn-cursor btn-teacher-dashboard ml-3"
        onClick={onCancel}
        disabled={isLoading}
      >
        Cancel
      </button>
      {error && (
        <span className="text-danger" style={{ marginLeft: 20 }}>
          {error}
        </span>
      )}
    </Fragment>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/Footer/index.js